const Axulliary=(props)=>props.children
export default Axulliary